import DynamicStyleComponent from "@shared/ui/dinamicStylesComponent/DynamicStyleComponent";
import { lazy, useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import GameSetup from "@widgets/layout/GameSetup";


export const basePath = import.meta.env.BASE_URL;

const LayoutLazy = lazy(() => import("../widgets/layout/Layout"));
const OauthPageLazy = lazy(() => import("../pages/authPage/OauthPage"));
const MainPageLazy = lazy(() => import("../pages/mainPage/MainPage"));
const MyGamesOauthRedirectPage = lazy(() => import("@pages/oauth/myGamesOauthRedirectPage/MyGamesOauthRedirectPage"));
const GoogleOAuthPage = lazy(() => import("@pages/oauth/googleOauthRedirectPage/GoogleOAuthPage"));
const FacebookOAuthPage = lazy(() => import("@pages/oauth/facebookOauthRedirectPage/facebookOauthRedirectPage"));
const SteamOpenIDPage = lazy(() => import("@pages/oauth/steamOpenIDPage/SteamOpenIDPage"));
const ShopPage = lazy(() => import("@pages/shop/ShopPage"));
const LeaderboardsPage = lazy(() => import("@pages/leaderboards/LeaderboardsPage"));
const DownloadPage = lazy(() => import("@/pages/downloadPage/DownloadPage"));
const TwitchPage = lazy(() => import("@/pages/twitchPage/TwitchPage"));
const PurchasePage = lazy(() => import("@pages/PurchasePage/PurchasePage"));
const Sandbox = lazy(() => import("@pages/sandbox/sandbox"));
const SupportPage = lazy(() => import( "@pages/supportPage/SupportPage"));
const HubPage = lazy(() => import( "@pages/hubPage/HubPage"));
const RedirectToExternal = ({ url }: { url: string }) => {
	useEffect(() => {
		window.location.href = url;
	}, [url]);
	return null;
};

export const AppRoutes = () => (
	<>
		<DynamicStyleComponent />
		<Routes>
			<Route path={""} element={<GameSetup />}>
				<Route path={`${basePath}shop/:game`} element={<ShopPage />} />
				<Route path={`${basePath}shop/:game/:filter`} element={<ShopPage />} />
				<Route path={`${basePath}auth/api/mygames/:game`} element={<MyGamesOauthRedirectPage />} />
				<Route path={`${basePath}auth/api/google/:mode/:game`} element={<GoogleOAuthPage />} />
				<Route path={`${basePath}auth/api/facebook/:mode/:game`} element={<FacebookOAuthPage />} />
				<Route path={`${basePath}auth/api/steam/:mode/:game`} element={<SteamOpenIDPage />} />

				<Route path={`${basePath}purchase`} element={<PurchasePage />} />
				<Route path={`${basePath}sandbox`} element={<Sandbox />} />
				<Route path={`${basePath}oauth2/:game`} element={<OauthPageLazy />} />
				<Route path={`${basePath}support/:support_category/:game`} element={<SupportPage />} />
				<Route path={`${basePath}support/:game`} element={<SupportPage />} />

				<Route path={`${basePath}`} element={<LayoutLazy />}>
					<Route path={`${basePath}leaderboards/:game`} element={<LeaderboardsPage />} />
					<Route path={`${basePath}hub/:game`} element={<HubPage />} />

					<Route path={`${basePath}`} element={<MainPageLazy />} />
					<Route path={`${basePath}:game`} element={<MainPageLazy />} />
					<Route path={`${basePath}download/:game`} element={<DownloadPage />} />
					<Route path={`${basePath}twitch/:game`} element={<TwitchPage />} />

				</Route>
				<Route path="*" element={<RedirectToExternal url="https://wishlistgames.net" />} />
			</Route>
		</Routes>
	</>
);
